import React from 'react';
import './LoadingIndicator.css';

const LoadingIndicator = ({
  loaded,
  children,
  colorSpinner,
  backgroundColor,
  style
}) => {
  if (loaded) {
    return children;
  }

  const spinnerStyle = {
    border: `4px solid  ${colorSpinner || '#1b3982'}`,
    borderTop: `4px solid transparent`,
    ...style
  };

  const loadingIndicatorStyle = {
    backgroundColor: backgroundColor
  };

  return (
    <div className="loading-indicator" style={loadingIndicatorStyle}>
      <div className="spinner" style={spinnerStyle}></div>
    </div>
  );
};

export default LoadingIndicator;
